import React from 'react';
import styled from 'styled-components';
import Video from '../video';
import { Container, Text } from '../../ui-components';

/**
 * @component SectionVideo
 * 
 * @param {object} props
 * 
 * @prop {string} embedUrl
 * @prop {string} title
 * @prop {string} subTitle
 * 
 * @returns {JSX}
 */
const SectionVideo = props => {
  const { embedUrl, title, subTitle } = props;

  if (embedUrl.includes('embed')) {
    return (
      <VideoContainer sectionContainer>
        <Video embedUrl={embedUrl} title={title} margin={'0px'} />
        <VideoSubtitle>
          <VideoTitle>{title}</VideoTitle>
          {subTitle}
        </VideoSubtitle>
      </VideoContainer>
    );
  }
};

const VideoContainer = styled(props => <Container {...props} />)`
  max-width: 850px;
  margin: auto;
`;

const VideoTitle = styled(Text)`
  text-align: center;
  font-weight: 900;
`;

const VideoSubtitle = styled(Text)`
  text-align: center;
  font-style: italic;
`;

export default SectionVideo;
